import {
  Avatar,
  Badge,
  Box,
  Checkbox,
  HStack,
  Icon,
  IconButton,
  Table,
  Image,
  Button,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Switch,
  Tr,
  useClipboard,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import { FiEdit2, FiTrash2, FiCopy, FiX } from "react-icons/fi";
import {
  FaTiktok,
  FaMailBulk,
  FaInstagram,
  FaSnapchatGhost,
} from "react-icons/fa";
import { KYDAdminEvent, KYDAffiliate } from "@common/interfaces/KYDEvent";
import { KYDMarketingPlatform } from "@common/interfaces/KYDOrganization";
import { capitalized } from "../utils";

const MarketingRow = ({
  link,
  platform,
}: {
  platform: KYDMarketingPlatform;
  link: string;
}) => {
  const { onCopy } = useClipboard(link);
  const toast = useToast();

  const platformIcon = (platform: KYDMarketingPlatform) => {
    if (platform === "email") {
      return <FaMailBulk size={"20px"} />;
    } else if (platform === "meta") {
      return <FaInstagram size={"20px"} />;
    } else if (platform === "snapchat") {
      return <FaSnapchatGhost size={"20px"} />;
    } else if (platform === "tiktok") {
      return <FaTiktok size={"20px"} />;
    }
  };

  return (
    <Tr>
      <Td>
        <HStack>
          {platformIcon(platform)}
          <Text fontWeight={"bold"}>{capitalized(platform)}</Text>
        </HStack>
      </Td>
      <Td>
        <HStack
          borderWidth={"1px"}
          rounded={"lg"}
          cursor={"pointer"}
          onClick={() => {
            onCopy();
            toast({
              title: "✅ Link copied",
              status: "success",
              duration: 5000,
              isClosable: true,
            });
          }}
          p={2}
        >
          <Text fontSize={"xs"}>{link}</Text>
          <FiCopy size="20px" />
        </HStack>
      </Td>
    </Tr>
  );
};

export const MarketingTable = ({
  kydEvent,
  ...props
}: {
  kydEvent: KYDAdminEvent;
}) => {
  const linkForEvent = (
    kydEvent: KYDAdminEvent,
    platform: KYDMarketingPlatform
  ) => {
    let utm_source = platform;
    let utm_campaign = "";
    let utm_medium = "";
    let utm_content = "";
    if (platform === "email") {
      utm_campaign = "email";
      utm_medium = "email";
      utm_content = "email";
    } else if (platform === "meta") {
      utm_campaign = "{{campaign.id}}";
      utm_medium = "{{placement}}";
      utm_content = "{{ad.id}}";
    } else if (platform === "snapchat") {
      utm_campaign = "{{campaign.id}}";
      utm_medium = "{{adSet.id}}";
      utm_content = "{{ad.id}}";
    } else if (platform === "tiktok") {
      utm_campaign = "__CAMPAIGN_ID__";
      utm_medium = "__PLACEMENT__";
      utm_content = "__CID__";
    }

    return `https://${kydEvent.organization?.slug_id}.kydlabs.com/e/${kydEvent.id}?utm_source=${utm_source}&utm_campaign=${utm_campaign}&utm_medium=${utm_medium}&utm_content=${utm_content}`;
  };

  return (
    <Table {...props}>
      <Thead>
        <Tr>
          <Th width={"50px"}>Platform</Th>
          <Th>Link</Th>
        </Tr>
      </Thead>
      <Tbody>
        <MarketingRow platform="meta" link={linkForEvent(kydEvent, "meta")} />
        <MarketingRow
          platform="tiktok"
          link={linkForEvent(kydEvent, "tiktok")}
        />
        <MarketingRow
          platform="snapchat"
          link={linkForEvent(kydEvent, "snapchat")}
        />
        <MarketingRow platform="email" link={linkForEvent(kydEvent, "email")} />
      </Tbody>
    </Table>
  );
};
